import { Component, SimpleChanges } from '@angular/core';

import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';

import { EFileSubmissionDisplayStatus } from '../../models/efile-submission-status.model';

import { Observable } from 'rxjs';

@Component({
  selector: 'spv2-efile-submission-status-dropdown',
  templateUrl: './dropdown-base/dropdown-base.component.html',
  styleUrls:['./dropdown-base/dropdown-base.component.scss']
})
export class EFileSubmissionStatusDropdownComponent extends DropdownBaseComponent<void, EFileSubmissionDisplayStatus> {

  uniqueName = "eFileSubmissionStatus";

  textField = "name";
  valueField = "statusses";
  
  valuePrimitive = false;
  enableCache = true;

  dataFunction = () => {
    return new Observable<EFileSubmissionDisplayStatus[]>(x => {
      x.next(EFileSubmissionDisplayStatus.all.filter(s => s.name != '-'));
      x.complete();
    })
  };

  constructor(cachingService: ApiCallCachingService) {
    super(cachingService);
  }
}
